module.exports = __webpack_public_path__ + "img/placket_width.36fb8d19.png";